import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted, ref, watch } from "vue";

export type ITab = { text: string, value: string, disabled?: boolean };

interface Props {
    tabs: ITab[];
    currentTab: string;
    size?: 'medium' | 'large';
    maxLenEllipsis?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePageTabs',
  props: {
    tabs: null,
    currentTab: null,
    size: { default: 'medium' },
    maxLenEllipsis: null
  },
  emits: ['update:current-tab'],
  setup(__props: any, { emit }) {

const props = __props as { tabs: ITab[], currentTab: string, size: 'medium' | 'large', maxLenEllipsis?: number }




const sliderPosition = ref<string>('');
const tabsContainer = ref<HTMLElement | null>(null);
const buttonRefs = ref([]);
const activeBtn = ref<HTMLElement | null>(null);

onMounted(() => {
    setActiveBtnRef();
    nextTick(() => scrollActiveTabIntoView());
});

watch(() => props.currentTab, () => {
    setActiveBtnRef();
    nextTick(() => scrollActiveTabIntoView());
});

const setActiveBtnRef = () => {
    const index = props.tabs.findIndex(tab => tab.value === props.currentTab);
    if (index === -1) return;
    activeBtn.value = buttonRefs.value[index];
    setSliderPosition();
};

const selectTab = (value: string) => {
    emit('update:current-tab', value);
};

const setSliderPosition = () => {
    const container = tabsContainer.value as HTMLElement;
    const btn = activeBtn.value as HTMLElement;
    const containerRect = container.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    const leftOffset = btnRect.left - containerRect.left - container.clientLeft;
    sliderPosition.value = `left: ${leftOffset}px; width: ${btnRect.width}px`;
};

const scrollActiveTabIntoView = () => {
    const btn = activeBtn.value;
    if (!btn) return;
    btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
};

return { __sfc: true,props, emit, sliderPosition, tabsContainer, buttonRefs, activeBtn, setActiveBtnRef, selectTab, setSliderPosition, scrollActiveTabIntoView }
}

})